import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Button, Stack, } from '@mui/material';
import { useNavigate } from 'react-router';
// import { observer } from 'mobx-react-lite';
// import { Link as RouterLink } from 'react-router-dom';
const HubToolbar = ({ type, }) => {
    const navigate = useNavigate();
    if (type === 'documents') {
        return (_jsx(Stack, { direction: "row", spacing: 2, margin: 2, justifyContent: "flex-end", children: _jsx(Button, { variant: "contained", onClick: () => navigate('./hub/document/new'), children: "Upload Document" }) }));
    }
    if (type === 'learnings') {
        return (_jsxs(Stack, { direction: "row", spacing: 2, margin: 2, justifyContent: "flex-end", children: [_jsx(Button, { variant: "contained", onClick: () => navigate('./hub/microcast/new'), children: "Create Microcast" }), _jsx(Button, { variant: "contained", onClick: () => navigate('./hub/course/new'), children: "Create Course" })] }));
    }
    if (type === 'meetings') {
        return (_jsxs(Stack, { direction: "row", spacing: 2, margin: 2, justifyContent: "flex-end", children: [_jsx(Button, { variant: "contained", onClick: () => navigate('./hub/meeting/new'), children: "Create a Clip" }), _jsx(Button, { variant: "contained", onClick: () => navigate('./hub/meeting/meetNow'), children: "Instant Meeting" }), _jsx(Button, { variant: "contained", onClick: () => navigate('./hub/meeting/new'), children: "Schedule Meeting" })] }));
    }
    return null;
};
HubToolbar.defaultProps = {};
HubToolbar.meta = {
    group: 'hub',
    name: 'Hub Toolbar',
    description: 'Shows Hub page toolbar with buttons for actions.',
    props: [
        {
            key: 'type',
            name: 'Type',
            type: 'selector',
            menuItems: [
                { value: 'documents', label: 'Documents', description: 'Show Documents Page actions' },
                { value: 'learnings', label: 'Learnings', description: 'Show Learnings Page actions' },
                { value: 'meetings', label: 'Meetings', description: 'Show Meetings Page actions' },
            ],
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'HubToolbar',
        props: {},
    },
};
export default observer(HubToolbar);
//# sourceMappingURL=HubToolbar.js.map